var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loaderCircle"}},[_c('div',{staticClass:"load",style:('border-top:2px solid')})])}
var staticRenderFns = []

export { render, staticRenderFns }